export const PWA_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_URL || (process.env.REACT_APP_BASE_URL || 'http://localhost:3000/api'),
  COMPANY_WEBSITE: process.env.REACT_APP_COMPANY_WEBSITE || window.location.hostname,
};

export default PWA_CONFIG;
